export const pricingPlans = [
  {
    id: 1,
    name: 'Basic Plan',
    type: 'monthly',
    price: 80,
    currency: 'USD',
    duration: 'per month',
    classes: '8 classes',
    classesPerWeek: '2 classes per week',
    classDuration: '30 minutes',
    features: [
      '2 classes per week',
      '30 minutes per class',
      'One-on-one sessions',
      'Flexible scheduling',
      'Progress reports',
      'WhatsApp support'
    ],
    popular: false,
    color: '#0D5C2E'
  },
  {
    id: 2,
    name: 'Standard Plan',
    type: 'monthly',
    price: 120,
    currency: 'USD',
    duration: 'per month',
    classes: '12 classes',
    classesPerWeek: '3 classes per week',
    classDuration: '30 minutes',
    features: [
      '3 classes per week',
      '30 minutes per class',
      'One-on-one sessions',
      'Flexible scheduling',
      'Progress reports',
      'WhatsApp support',
      'Free trial class',
      'Priority support'
    ],
    popular: true,
    color: '#B8860B'
  },
  {
    id: 3,
    name: 'Premium Plan',
    type: 'monthly',
    price: 160,
    currency: 'USD',
    duration: 'per month',
    classes: '20 classes',
    classesPerWeek: '5 classes per week',
    classDuration: '30 minutes',
    features: [
      '5 classes per week',
      '30 minutes per class',
      'One-on-one sessions',
      'Flexible scheduling',
      'Detailed progress reports',
      '24/7 WhatsApp support',
      'Free trial class',
      'Priority support',
      'Monthly assessment',
      'Certificate on completion'
    ],
    popular: false,
    color: '#059669'
  },
  {
    id: 4,
    name: 'Intensive Plan',
    type: 'monthly',
    price: 200,
    currency: 'USD',
    duration: 'per month',
    classes: '20 classes',
    classesPerWeek: '5 classes per week',
    classDuration: '60 minutes',
    features: [
      '5 classes per week',
      '60 minutes per class',
      'One-on-one sessions',
      'Flexible scheduling',
      'Detailed progress reports',
      '24/7 WhatsApp support',
      'Free trial class',
      'VIP support',
      'Weekly assessment',
      'Certificate on completion',
      'Free course materials',
      'Lifetime access to recordings'
    ],
    popular: false,
    color: '#0A3D1F'
  }
];

export const paymentMethods = [
  {
    id: 1,
    name: 'PayPal',
    description: 'Secure payment via PayPal',
    icon: 'FaCcPaypal',
    available: true,
    processingTime: 'Instant',
    fees: 'No additional fees'
  },
  {
    id: 2,
    name: 'Credit/Debit Card',
    description: 'Visa, Mastercard, American Express',
    icon: 'FaCreditCard',
    available: true,
    processingTime: 'Instant',
    fees: 'No additional fees'
  },
  {
    id: 3,
    name: 'Bank Transfer',
    description: 'Direct bank transfer',
    icon: 'FaUniversity',
    available: true,
    processingTime: '1-3 business days',
    fees: 'Bank charges may apply'
  },
  {
    id: 4,
    name: 'Western Union',
    description: 'International money transfer',
    icon: 'FaMoneyCheckAlt',
    available: true,
    processingTime: 'Same day',
    fees: 'Transfer fees apply'
  },
  {
    id: 5,
    name: 'Wise (TransferWise)',
    description: 'Low-cost international transfers',
    icon: 'FaExchangeAlt',
    available: true,
    processingTime: '1-2 business days',
    fees: 'Low transfer fees'
  },
  {
    id: 6,
    name: 'Cryptocurrency',
    description: 'Bitcoin, Ethereum, USDT',
    icon: 'FaBitcoin',
    available: true,
    processingTime: 'Within 1 hour',
    fees: 'Network fees apply'
  }
];

export const faqData = [
  {
    id: 1,
    question: 'Can I change my plan later?',
    answer: 'Yes, you can upgrade or downgrade your plan at any time. The changes will take effect from your next billing cycle.'
  },
  {
    id: 2,
    question: 'Is there a refund policy?',
    answer: 'We offer a 7-day money-back guarantee if you are not satisfied with our service. Contact us within 7 days of payment for a full refund.'
  },
  {
    id: 3,
    question: 'Can I pause my subscription?',
    answer: 'Yes, you can pause your subscription for up to 2 months. Contact our support team to arrange this.'
  },
  {
    id: 4,
    question: 'Do you offer family discounts?',
    answer: 'Yes! We offer 10% discount for 2 students from the same family, and 15% discount for 3 or more students.'
  },
  {
    id: 5,
    question: 'What payment methods do you accept?',
    answer: 'We accept PayPal, Credit/Debit cards, Bank transfers, Western Union, Wise, and Cryptocurrency.'
  }
];
